import generateID from '@/utils/generate-id';
import { buildAstState } from '..';

const _getMaxNameNum = (nodes: Ast[], prefix: string) => {
  let num = 0;
  nodes.forEach((node) => {
    const name = node.attrsMap.name ?? '';
    const _num = Number(name.replace(prefix, ''));

    if (Number.isNaN(_num)) {
      //
    } else {
      num = Math.max(num, _num);
    }
  });

  return num;
};

export const generateResourceName = (resourceAst: Ast, tag: string) => {
  const prefix = tag.replace('DataItem', '');
  // 非editor时，无需按顺序生成（可加快生成）
  if (buildAstState.options.buildFor == 'editor') {
    return prefix + '_' + generateID();
  }
  const maxNum = _getMaxNameNum(resourceAst.children ?? [], prefix);
  return prefix + (maxNum + 1);
};

export const getRefName = (ref: string | undefined) => {
  return ref ? '@' + ref : '';
};

export const encodeHTMLEntities = (s: string) => {
  const div = document.createElement('div');
  div.textContent = s;
  return div.innerHTML;
};
